export class FiltroEmitirRelatorioModel {
  public tipoRelatorio?: number;
  public relatorio: number;
  public sorteio: number;
  public nomeSorteio: number;
}



// WEBPACK FOOTER //
// ./src/app/shared/model/filtro-relatorio.model.ts